import React from "react";

function SectionHeading({
    eyebrow,
    title,
    subtitle,
}: {
    eyebrow?: string;
    title: string;
    subtitle?: string;
}) {
    return (
        <div className="mx-auto mb-10 max-w-3xl text-center">
            {eyebrow ? (
                <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70">
                    <span className="h-2 w-2 rounded-full bg-white/60" />
                    {eyebrow}
                </div>
            ) : null}
            <h2 className="text-balance text-2xl font-semibold tracking-tight text-white sm:text-3xl">
                {title}
            </h2>
            {subtitle ? (
                <p className="mt-3 text-pretty text-sm text-white/70 sm:text-base">{subtitle}</p>
            ) : null}
        </div>
    );
}

export default function SecurityIntegrations() {
    const items = [
        { title: "Minimalne uprawnienia", desc: "Bot prosi tylko o to, co niezbędne do modułów." },
        { title: "Prywatność i RODO", desc: "Czytelne zasady przechowywania danych i export." },
        { title: "Discord API & Webhooki", desc: "Integracje pod eventy, logi i automatyzacje." },
        { title: "Integracje", desc: "Stripe / Notion / Google Sheets — opcjonalnie." },
    ];

    return (
        <section className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
            <SectionHeading
                eyebrow="Zaufanie"
                title="Bezpieczeństwo i integracje"
                subtitle="Stabilne działanie, audyt i przejrzysta konfiguracja."
            />
            <div className="grid gap-4 md:grid-cols-2">
                {items.map((it) => (
                    <div
                        key={it.title}
                        className="rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur"
                    >
                        <div className="text-sm font-semibold text-white">{it.title}</div>
                        <p className="mt-2 text-sm text-white/70">{it.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
